
























































import Vue from "vue";
import ApiService from "@/services/ApiService";
import { apiUrl } from "@/domain";
import dbConnection from "@/services/dbConnection";

// import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
export default Vue.extend({
    name: "StepAccountManagementModal",
    components: {
        // OrgSelectionAdmin,
    },
    data() {
        return {
            form: {
                id: null,
                step_title: "",
                email: "",
                first_name: "",
                entity_type: "",
                domain_ids: "",
                password: null
            },
            loading: false,
            responseInfo: {
            },
            accounts_list: [],
            accountTypes: [
                // { label: "Superadmin", value: "SUPERADMIN" },
                { label: "Council", value: "COUNCIL" },
                { label: "District", value: "DISTRICT" },
                { label: "School", value: "SCHOOL" },
                { label: "Multi-council", value: "MULTI_COUNCIL" },
            ],
        };
    },
    methods: {
        async submitForm() {
            this.$refs["accountForm"].validate((valid) => {
                if (valid) {
                    this.submitAccount();
                }
            });
        },
        async submitAccount() {
            if (!this.form.email || !this.form.step_title || !this.form.entity_type) {
                this.$notify.error({
                    title: "Error",
                    message: "Please fill all the fields",
                });
                this.loading = false;
                return;
            }
            try {
                const submitResponse = await ApiService.stepApi.submitAccount(
                    {
                        id: this.form.id ?? null,
                        step_title: this.form.step_title,
                        email: this.form.email,
                        first_name: this.form.step_title,
                        entity_type: this.form.entity_type,
                        domain_ids: this.form.domain_ids,
                        password: this.form.password
                    }
                );

                this.$notify.info({
                    title: "Saved",
                    message: "Good things just happened!",
                });
                this.getAccounts();
                this.resetForm();
                // this.$emit("close");
            } catch (error) {
                // console.error("Upload failed", error);
                this.$notify.error({
                    title: "Error",
                    message: "Failed to save account: " + error.response.data.error,
                });
            } finally {
                this.loading = false;
            }
        },
        resetForm() {
            this.form = {
                id: null,
                step_title: "",
                email: "",
                first_name: "",
                entity_type: "",
                domain_ids: "",
                password: null
            };
        },
        close() {
            this.$emit("close");
        },
        editAccount(id) {
            const formData = this.accounts_list.find(account => account.id === id);
            this.form = {
                id: formData.id,
                step_title: formData.step_title,
                email: formData.email,
                first_name: formData.step_title,
                entity_type: formData.entity_type,
                domain_ids: formData.domain_ids,
                password: formData.password
            };
        },
        deleteAccount(id) {
            ApiService.stepApi.deleteAccount(id).then(() => {
                this.$notify.info({
                    title: "Deleted",
                    message: "Deleted!",
                });
                this.getAccounts();
            });
            // this.$emit("deleteAccount", id);
        },
        // async copyText(mytext) {
        //     try {
        //         await navigator.clipboard.writeText(mytext);
        //         this.$notify.info({
        //             title: "Copied",
        //         });
        //     } catch ($e) {
        //         alert("Cannot copy");
        //     }
        // },
        async getAccounts() {
            try {
                const response = await ApiService.stepApi.getAccounts();
                this.accounts_list = response.data;
            } catch (error) {
                console.error(error);
            }
        },
    },
    mounted() {
        this.getAccounts();
    },
});
